<template>
  <el-dialog
    title="Add New Widget"
    visible
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-row :gutter="15">
      <el-col :span="8">
        <el-card shadow="never">
          <h3>Available Widgets:</h3>
          <el-tree
            :data="treeData"
            @node-click="handleNodeClick"
          />
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card shadow="never">
          <component
            :is="selectedConfigure"
            v-if="selectedConfigure"
            ref="configure"
            @submitted="submitted"
          />
          <p v-else>
            Please select a widget from the left
          </p>
        </el-card>
      </el-col>
    </el-row>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button
        @click.native="$emit('update:isShow', false)"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        :disabled="!selectedConfigure"
        @click.native="add"
      >
        Add Widget
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    widgets: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isFullscreen: false,
      treeData: [],
      selectedConfigure: null
    }
  },
  created () {
    Object.keys(this.widgets).map(key => {
      if (this.widgets[key].name && this.widgets[key].configure) {
        this.treeData.push({
          label: this.widgets[key].name || 'Unknown',
          configure: this.widgets[key].configure
        })
      }
    })
  },
  methods: {
    handleNodeClick (data) {
      this.selectedConfigure = data.configure
    },
    add () {
      this.$refs.configure.submit()
    },
    submitted (widget) {
      this.$emit('submitted', widget)
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style>

</style>
